export default __webpack_public_path__ + "static/media/product-cross.b5afa70e.svg";